import { formatCurrency } from '@angular/common';

import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import {ButtonData} from '../mapping-classes/button-data';

export class Onlinekeyarrangement implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  private cards: [] = null;

  constructor(response: any) {
    this.title = 'Rabo Online Key Card';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.cards = response.detailsViewObject.cards || null;
      this.title = response.detailsViewObject.commercialProductTypeName || 'Rabo GoldCard';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues(response);
      this.addValues(response);
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    if (this.cards && this.cards.length) {
      this.panels.push(new DetailPanel('Passen'));
    }
  }

  setNameAndValues(response?) {
    const cards = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillProductDetailsPanel(productDetailsPanel);

    const cardsPanel: DetailPanel = this.panels[1];

    if (cards.cards && cards.cards.length) {
      this.addSubHeaderToPanel(cardsPanel, '');
    }

    if (cards.requestedcards && cards.requestedcards.length) {
      this.addSubHeaderToPanel(cardsPanel, 'Aanvragen passen / laatste PIN mailer');
    }
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);

    if (obj.cards) {
      const cardsPanel: DetailPanel = this.panels[1];
      this.addValuesToCardsPanel(cardsPanel, obj);
    }
  }

  addButtons(response) {
    this.buttons.push(new ButtonData('productservicesurl', response.detailsViewObject['arrangementNumber'],
      response.detailsViewObject['administrationCode'], response.detailsViewObject['commercialProductTypeCode'],
      'Productservice'));
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('arrangementNumber', new DetailLabel('Overeenkomstnummer'));
    productDetailsPanel.nameAndValues.set('status', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('firstName', new DetailLabel('Naam 1'));
    productDetailsPanel.nameAndValues.set('secondName', new DetailLabel('Naam 2'));
    productDetailsPanel.nameAndValues.set('accountNumber', new DetailLabel('Rekeningnummer'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('arrangementNumber').setValue(obj.arrangementNumber || '-');
    productDetailsPanel.nameAndValues.get('status').setValue(obj.status || '-');
    productDetailsPanel.nameAndValues.get('firstName').setValue(obj.firstName || '-');
    productDetailsPanel.nameAndValues.get('secondName').setValue(obj.secondName || '-');
    productDetailsPanel.nameAndValues.get('accountNumber').setValue(obj.accountNumber || '-');
  }

  private addValuesToCardsPanel(cardsPanel: DetailPanel, obj) {
    if (obj.cards) {
      this.addTable(cardsPanel, obj, 'onlinekeycards', 0);
    }

    if (obj.requestedcards) {
      this.addTable(cardsPanel, obj, 'onlinekeyrequestedcards', 1);
    }
  }

  private addTable(panel: DetailPanel, obj, table, index) {

    // tslint:disable-next-line:no-shadowed-variable
    const tables = ( table ): string => {
      const tablesType = {
        onlinekeycards: 'cards',
        onlinekeyrequestedcards: 'requestedcards',
      };

      return tablesType[table];
    };

    panel.subPanels[index].hasTable = true;
    panel.subPanels[index].lazyLoadingData =
      new LazyLoadingData(null, null, table);

    if (obj[tables(table)] && obj[tables(table)].length !== 0) {
      obj[tables(table)].forEach((_table) => {
        _table.restrictedData = obj.restrictedData;
      });
      panel.subPanels[index].lazyLoadingData.data = obj[tables(table)];
    }
  }
}
